import { UnusedSkipTokenOptions, useQuery } from '@tanstack/react-query'
import { transactionStatisticsQueryOptions } from './options'
import type {
	GetTransactionStatisticsParams,
	TransactionStatisticsResponse,
} from '../../../types'

export default function useQueryTransactionStatistics(
	params?: GetTransactionStatisticsParams,
	options?: UnusedSkipTokenOptions<TransactionStatisticsResponse>,
) {
	return useQuery(transactionStatisticsQueryOptions(params, options))
}
